export const EMAIL_URL_PARAM = 'email';
export const BOOKING_NUMBER_URL_PARAM = 'bookingNumber';

export interface ManageBookingUrlParams {
  email?: string;
  bookingNumber?: string;
}

const normalize = (value: string | null): string | undefined =>
  value?.trim() || undefined;

/**
 * Reads the Manage Booking deep-link parameters (`email`, `bookingNumber`) from a
 * URL query string. Defaults to the current location so callers can invoke it with
 * no arguments; an explicit string is accepted for testing.
 */
export const parseManageBookingUrlParams = (
  search: string = window.location.search
): ManageBookingUrlParams => {
  const searchParams = new URLSearchParams(search);

  return {
    email: normalize(searchParams.get(EMAIL_URL_PARAM)),
    bookingNumber: normalize(searchParams.get(BOOKING_NUMBER_URL_PARAM)),
  };
};
